import React from 'react';

import api, { urlParamCharacter } from '../services/api';
import Address from './Address';
import Contact from './Contact';
import Credits from './Credits';

export default class Footer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      addresses: [],
      contacts: [],
    };
  }

  componentDidMount() {
    api.get(`/addresses${urlParamCharacter}orderby=menu_order&order=asc`)
      .then((response) => {
        this.setState({
          addresses: response.data,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });

    api.get(`/contacts${urlParamCharacter}orderby=menu_order&order=asc`)
      .then((response) => {
        this.setState({
          contacts: response.data,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });
  }

  render() {
    const { addresses, contacts } = this.state;

    return (
      <footer className="Footer container">
        <h2 className="sr-only">Contacts</h2>
        <div id="footer">
          <h3 className="sr-only">Addresses</h3>
          <ul className="Footer__list Footer__list--addresses">
            {addresses.map((address) => (
              <Address
                key={address.slug}
                title={address.title.rendered}
                city={address.acf.city}
                mailOnly={address.acf.mail_only}
                address={address.acf.address}
                telephoneNumber={address.acf.telephone_number}
                faxNumber={address.acf.fax_number}
                isFooter
              />
            ))}
          </ul>
          <h3 className="sr-only">Personnel</h3>
          <ul className="Footer__list Footer__list--contacts">
            {contacts.map((contact) => (
              <Contact
                key={contact.slug}
                title={contact.title.rendered}
                role={contact.acf.role}
                email={contact.acf.email}
                phone={contact.acf.phone}
                isFooter
              />
            ))}
          </ul>
        </div>
        <Credits />
      </footer>
    );
  }
}
